import cdnApi from './api-cdn';
import coreApi from './api-core';

const pluginAPI = {
	install(Vue) {
		Vue.prototype.$cdnAPI = cdnApi;
		Vue.prototype.$coreAPI = coreApi;
	},
};

export default pluginAPI;
